import { render, staticRenderFns } from "./QFooterDetails.vue?vue&type=template&id=5cd72e3d&"
import script from "./QFooterDetails.vue?vue&type=script&lang=js&"
export * from "./QFooterDetails.vue?vue&type=script&lang=js&"
import style0 from "./QFooterDetails.vue?vue&type=style&index=0&id=5cd72e3d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports